import { render, staticRenderFns } from "./Language_Independance.vue?vue&type=template&id=70326770&scoped=true"
import script from "./Language_Independance.vue?vue&type=script&lang=js"
export * from "./Language_Independance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70326770",
  null
  
)

export default component.exports